import { post,get,del,put } from './reject'

export const getlogin = params => post('/operation/toLogin', params); //登录

export const getloginout = params => post('/operation/logout', params); //退出登录

export const getCurriculum = params => post('/courseManagent/selectPage', params); //课程管理列表

export const getNoTop = params => post('/courseManagent/cancelTop', params); //课程管理取消置顶

export const getinformation = params => post('/courseManagent/selectById', params); //获取课程信息

export const getExinformation = params => post('/courseManagent/selectById', params); //获取精品课程信息

export const getNewcourses = params => post('/courseManagent/addCourseManagent', params); //新增课程

export const getModcourses = params => post('/courseManagent/updateCourseManagent', params); //修改课程

export const getClassification = params => post('/courseType/selectParentType', params); //课程分类查询

export const getcourseification = params => post('/courseType/selectPrimaryType', params); //课程分类二级联动查询

export const getModClassification = params => post('/courseType/updateCourseType', params); //修改课程分类

export const getAddClassification = params => post('/courseType/addCourseType', params); //添加课程分类

export const getAddHotClassification = params => post('/courseType/addCourseType', params); //添加热门课程分类

export const getModHotClassification = params => post('/courseType/updateCourseType', params); //修改热门课程分类

export const getDelCurriculum = params => post('/courseType/deleteCourseType', params); //删除课程分类

export const getClassificationSub = params => post('/courseType/selectSubTypePage', params); //课程二级分类查询

export const getSearchQuery = params => post('/courseManagent/selectPage', params); //课程搜索

export const getDelcourse = params => post('/courseManagent/deleteCourseManagent', params); //删除课程管理

export const chaindata = params => post('/courseManagent/setTop', params); //课程管理置顶

export const getremakes = params => post('/worksView/selectPage', params); //作品赏析列表

export const getaddfremakes = params => post('/worksView/addWorks', params); //新增作品赏析

export const getmodfremakes = params => post('/worksView/updateWorks', params); //作品赏析修改

export const getdelfremakes = params => post('/worksView/deleteWorks', params); //作品赏析删除

export const getMenuData = params => post('/menu/selectMenu', params); // 操作菜单

export const getroleAdd = params => post('/role/addRole', params); // 添加角色

export const getroleList = params => post('/role/selectPage', params); // 账号角色列表

export const getroleDetail = params => post('/role/selectById', params); // 角色详情

export const getroleDel = params => post('/role/deleteRole', params); // 角色删除

export const getModrole = params => post('/role/updateRole', params); // 修改角色权限

export const getusersList = params => post('/operation/selectPage', params); // 用户列表

export const getusersAdd = params => post('/operation/addOperation', params); // 账号添加

export const getusersMod = params => post('/operation/updateOperation', params); // 账号修改

export const getpasswordTopMod = params => post('/operation/updatePassword', params); // 修改密码

export const getusersDel = params => post('/operation/deleteOperation', params); // 账号删除

export const getGoodslist = params => post('/goods/selectPage', params); // 商品列表

export const getGoodslistSearch = params => post('/goods/selectPage', params); // 搜素商品

export const getUpshelf = params => post('/goods/updaerSell', params); // 商品上架

export const getWnshelf = params => post('/goods/updaerSell', params); // 商品下架

export const getDelGoodslist = params => post('/goods/deleteGoods', params); // 删除商品

export const getGoodsimfo = params => post('/goods/selectById', params); // 商品详情

export const getModGoodsimfo = params => post('/goods/updateGoods', params); // 修改商品详情

export const getComclassification = params => post('/goodsType/selectPage', params); // 商品分类列表

export const getAddclassification = params => post('/goodsType/addGoodsType', params); // 商品分类添加

export const getModclassification = params => post('/goodsType/updateGoodsType', params); // 商品分类修改

export const getDelclassification = params => post('/goodsType/deleteGoodsType', params); // 商品分类删除

export const getAddgoods = params => post('/goods/addGoods', params); // 商品上传

export const getMaterial = params => post('/materialInfo/selectPage', params); // 文字素材列表

export const getDelMaterial = params => post('/materialInfo/deleteMaterialInfo', params); // 文字素材删除

export const getMaterialDetails = params => post('/materialInfo/selectById', params); // 文字素材内容详情

export const getMaterialEditorial = params => post('/materialInfo/updateMaterialInfo', params); // 文字素材内容修改

export const getselectPrimary = params => post('/courseType/selectPrimary', params); // 文字素材一级分类

export const getselectSecondType = params => post('/courseType/selectSecondType', params); // 文字素材二级分类

export const getselectCourseName = params => post('/courseManagent/selectCourseName', params); // 文字素材三级分类

export const getaddMaterial = params => post('/materialInfo/addMaterialInfo', params); // 添加文字素材

export const getMechanism = params => post('/organization/selectApplyPage', params); // 机构申请列表

export const getMechanismDel = params => post('/organization/deleteOrganization', params); // 机构删除

export const getInstitutional = params => post('/organizationUser/selectPage', params); // 机构用户列表

export const getMoneyback = params => post('/organizationUser/batchExamine', params); // 回款确认

export const getModrebate = params => post('/organizationUser/updateBackMoney', params); // 修改返利金额

export const getInstitutionalDel = params => post('/organizationUser/selectById', params); // 机构用户详情

export const getreview = params => post('/organization/toExamine', params); // 机构审核

export const getfinancialList = params => post('/user/selectMemeber', params); // 财务数据列表

export const getOrderInfo = params => post('/orderInfo/selectPage', params); // 订单列表

export const getExpress = params => post('/orderInfo/updateOrder', params); // 修改快递

export const getExpressDetail = params => post('/orderInfo/selectById', params); // 订单详情

export const getExpressDel = params => post('/orderInfo/deleteOrder', params); // 订单删除

export const getPatclassification = params => post('/imageCategory/selectPage', params); // 图案分类

export const getPictureAdd = params => post('/imageCategory/addImageCategory', params); // 图案分类添加

export const getPictureMod = params => post('/imageCategory/updateImageCategory', params); // 图案分类修改

export const getPictureDel = params => post('/imageCategory/deleteImageCategory', params); // 图案分类删除

export const getPatternclass = params => post('/imageManage/selectPage', params); // 根据分类查询管理列表

export const getPatternAdd = params => post('/imageManage/addImageManage', params); // 图案添加

export const getPatternDetail = params => post('/imageManage/selectById', params); // 获取图案管理详情

export const getPatternMod = params => post('/imageManage/updateImageManage', params); // 图案修改

export const getPatternDel = params => post('/imageManage/deleteImageManage', params); // 删除图案

export const getTypesetting = params => post('/typesettingManage/selectPage', params); // 获取排版列表

export const getAddTypesetting = params => post('/typesettingManage/addTypesettingManage', params); // 新增排版列表

export const getTypesettingMod = params => post('/typesettingManage/updateTypesettingManage', params); // 修改排版

export const getTypesettingDel = params => post('/typesettingManage/deleteTypesettingManage', params); // 删除排版

export const getTypesettitle = params => post('/titleFrame/selectPage', params); // 获取边框列表

export const getFrameAdd = params => post('/titleFrame/addTitleFrame', params); // 新增边框

export const getFrameMod = params => post('/titleFrame/updateTitleFrame', params); // 修改边框

export const getFrameDel = params => post('/titleFrame/deleteTitleFrame', params); // 删除边框

export const getuserList = params => post('/user/selectUser', params); // 用户管理列表

export const getpullBlack = params => post('/user/updateStatus', params); // 用户拉黑

export const getJurisdiction = params => post('/menu/selectRoleMenu', params); // 用户菜单权限

export const getScreening = params => post('/screening/selectScreening'); // 数据总览

export const getTransaction = params => post('/transaction/getCount', params); // 交易概况统计

export const getLine = params => post('/transaction/getLine', params); // 交易概况折线图

export const getRank = params => post('/rank/selectRank', params); // 排行榜

export const getChannel = params => post('/channel/selectChannel', params); // 排行榜

export const getBaseInfo = params => post('/baseInfo/statistics', params); // 基本信息

export const getSelectLineChart = params => post('/baseInfo/selectLineChart', params); // 基本信息折线图

export const getGrouplist = params => get('http://gapi.eduscb.com/api/drawing/group/strategy/list', params); // 团购列表

export const getAddGroup = params => post('http://gapi.eduscb.com/api/drawing/group/strategy', params); // 添加团购

export const getGroupDetail = params => get('http://gapi.eduscb.com/api/drawing/group/strategy', params); // 团购详情

export const getorder = params => get('http://gapi.eduscb.com/api/drawing/group/order/list', params); // 团购订单

export const getgroupedit = params => del('http://gapi.eduscb.com/api/drawing/group/strategy', params); // 团购删除

export const getgroupdel = params => del('http://gapi.eduscb.com/api/drawing/group/strategy', params); // 团购删除

export const getonline = params => put('http://gapi.eduscb.com/api/drawing/group/strategy/online/json', params); // 团购删除

export const getorders = params => get('http://gapi.eduscb.com/api/drawing/group/strategy/list/order', params); // 团购订单

export const getChannelList = params => post('/channel/selectUserChannelList', params); // 兑换码

export const getCodeList = params => post('/orderInfo/getRedeemCode', params); // 兑换码

export const getCashout = params => get('/cashOut', params); // 机构体现列表

export const editCashout = params => put('/cashOut?id='+params.id+'&state='+params.state+'&remark='+params.remark); // 机构体现修改

export const getCashoutDetail = params => get('/cashOut/'+params.id); // 机构体现查询

export const getSpeed = params => get('/cashOut/selectOrder/'+params.id); // 体现订单查询

export const getFeedBack = params => get('/feedback/findAll',params); // 用户反馈列表

export const getFeedDetail = params => get('/feedback/'+params.id); // 用户反馈详情

export const getSolve = params => put('/feedback?id='+params.id+'&state='+params.state); // 用户反馈列表

export const getinstitution = params => get('/organizationUser/selectUserByOrganizationId',params); // 机构用户


// WEBPACK FOOTER //
// ./src/api/api.js